import ListingsRoutingResolver from './ListingRoutingResolver';

class OcrListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "ocr"
    }
}

export default OcrListingResolver
